<div class="server-settings-root">
  <form [formGroup]="form">
    <div class="mb-3 server-settings-row-1">
      <h1 class="server-settings-heading-1">Parent Server</h1>
    </div>
    <div class="server-settings-row-2">
      <span class="parent-server-label">Parent Server URL:</span>
      <input type="text" pInputText class="parent-server-field" [formControl]="serverUrl" />
    </div>
    @if (form.hasError('invalidServerUrl')) {
      <div class="server-settings-row-2">
        <span class="parent-server-error alert alert-danger">This field is required.</span>
      </div>
    }
    <div class="mb-3"></div>
    <div class="server-settings-row-2">
      <span class="parent-server-label">Parent Server API Key:</span>
      <input type="text" pInputText class="parent-server-field" [formControl]="serverApiKey" />
    </div>
    @if (form.hasError('invalidServerApiKey')) {
      <div class="server-settings-row-2">
        <span class="parent-server-error alert alert-danger">This field is required.</span>
      </div>
    }

    <div class="server-settings-divider"></div>
    <div class="mb-3 server-settings-row-2">
      <input class="" type="checkbox" [formControl]="syncEnabled" (change)="enableDisableControls()" />
      <span class="uv-checkbox-label">Enable Syncing with Parent Server</span>
    </div>
    <div class="mb-3 server-settings-row-2" style="align-items: center;">
      <span class="parent-server-label">Sync Interval (minutes):</span>
      <input class="form-control parent-server-numeric-field" type="number" [formControl]="syncInterval" />
      <info width="300px">
        <div style="text-align: left;">
          The frequency at which the local server should sync with the parent server
        </div>
      </info>
    </div>
    @if (form.hasError('invalidSyncInterval')) {
      <div class="mb-3 server-settings-row-2">
        <span class="parent-server-error alert alert-danger">The value of this field must be in the range 1 - 1440.</span>
      </div>
    }
    <div class="mb-3" style="margin-left: 57px; align-items: center;">
      <input class="" type="checkbox" [formControl]="awolEnabled" (change)="enableDisableControls()" />
      <span class="uv-checkbox-label">Alert when sync has not occurred for</span>
      <input class="form-control awol-input" type="number" min="0" max="30" [formControl]="awolDays" />
      <span class="awol-text">days</span>
      <input class="form-control awol-input" type="number" min="0" max="23" [formControl]="awolHours" />
      <span class="awol-text">hours</span>
      <input class="form-control awol-input" type="number" min="0" max="59" [formControl]="awolMinutes" />
      <span class="awol-text">minutes</span>
    </div>
    @if (form.hasError('invalidAwolInterval')) {
      <div class="mb-3 server-settings-row-2">
        <span class="parent-server-error alert alert-danger">
          A non-zero interval must be specified.<br />Days 0 - 30, Hours 0 - 23, Minutes 0 - 59.
        </span>
      </div>
    }
    <div class="mb-3 server-settings-row-2" [ngClass]="{'awol-server': isSuperServerAwol}">
      <span style="margin-right: 10px;">Last Sync Start Time:</span>
      <span>{{formatDateHm(lastSyncStartTime.value)}}</span>
    </div>
    <div class="mb-3  server-settings-row-2" [ngClass]="{'awol-server': isSuperServerAwol}">
      <span style="margin-right: 10px;">Last Sync End Time:</span>
      <span>{{formatDateHm(lastSyncEndTime.value)}}</span>
    </div>
    <div class="server-settings-divider"></div>
    <div class="mb-3 server-settings-row-2">
      <span class="parent-server-label">Local Server Display Name:</span>
      <input type="text" pInputText class="parent-server-field" [formControl]="name" />
    </div>
    @if (form.hasError('invalidName')) {
      <div class="mb-3 server-settings-row-2">
        <span class="parent-server-error alert alert-danger">This field is required.</span>
      </div>
    }
    <div class="mb-3 server-settings-row-2">
      <span class="parent-server-label">Local Server ID:</span>
      <span class="parent-server-field">{{serverId.value}}</span>
    </div>
    <div class="mb-3 server-settings-row-2">
      <span class="parent-server-label">Local Tenant ID:</span>
      <span class="parent-server-field">{{tenantId.value}}</span>
    </div>
    <div class="server-settings-divider"></div>
    <div class="mb-3 server-settings-row-6">
      <button type="button" (click)="tryUpdateSuperServer()" [disabled]="!enableUpdateSuperServerButton"
        pButton label="Update Parent Server" class="update-super-button">
      </button>
      <button type="button" (click)="tryUnlinkSuperServer()" [disabled]="!enableUnlinkSuperServerButton"
        pButton label="Unlink Parent Server" class="unlink-super-button">
      </button>
      <button type="button" (click)="syncNow()" [disabled]="!enableSyncNowButton"
        pButton label="Sync Now" class="sync-now-button">
      </button>
    </div>

    <hr class="server-settings-divider">

    <div class="mb-3 server-settings-row-1">
      <h1 class="server-settings-heading-1">Child Servers</h1>
    </div>
    @if (!!subServers && subServers.length > 0) {
      <div>
        <!-- Search Box-->
        <div style="margin-top: 20px; margin-bottom: 10px;">
          <i class="fa fa-filter search-icon"></i>
          <input type="text" pInputText size="50" placeholder="Filter"
            (input)="tt.filterGlobal($event.target.value, 'contains')" style="width:auto">
          </div>
          <!-- Data table -->
          <p-table #tt [value]="subServers" [globalFilterFields]="['Name']" rowHover="true"
            [scrollable]="true" [resizableColumns]="true">
            <ng-template pTemplate="header">
              <tr>
                <th pResizableColumn>Name</th>
                <th pResizableColumn>Server ID</th>
                <th pResizableColumn>Tenant ID</th>
                <th pResizableColumn>API Key</th>
                <th pResizableColumn>Sync Interval</th>
                <th pResizableColumn>Last Sync Start Time</th>
                <th pResizableColumn>Last Sync End Time</th>
                <th pResizableColumn>Sync Alerts</th>
                <th pResizableColumn>Modified</th>
                <th class="uv-table-button-column-2"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr>
                <td>
                  <span class="uv-table-value">{{ rowData.Name }}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{ rowData.SubServerGuid }}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{ rowData.SubTenantGuid }}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{ rowData.ApiKey }}</span>
                </td>
                <td>
                  <span class="uv-table-value">Every {{ rowData.SyncInterval }} minutes</span>
                </td>
                <td [ngClass]="{'awol-server': rowData.Awol}">
                  <span class="uv-table-value">{{ formatDateHm(rowData.LastSyncStartTime) }}</span>
                </td>
                <td [ngClass]="{'awol-server': rowData.Awol}">
                  <span class="uv-table-value">{{ formatDateHm(rowData.LastSyncEndTime) }}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{ syncAlertsString(rowData) }}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{ formatDateHm(rowData.Modified) }}</span>
                </td>
                <td class="uv-table-button-column-2">
                  <button type="button" (click)="tryUnlinkSubServer($event, rowData)" pButton label="Unlink" class="unlink-sub-button">
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
      @if (!subServers || subServers.length == 0) {
        <div>
          <h3>None</h3>
        </div>
      }
    </form>

    <confirmation-dialog message="Are you sure you want to update the parent server?"
      [display]="displayUpdateSuperServerConfirm"
      (onYes)="updateSuperServer()" (onNo)="cancelUpdateSuperServer()">
    </confirmation-dialog>

    <confirmation-dialog message="Are you sure you want to unlink from the parent server?"
      [display]="displayUnlinkSuperServerConfirm"
      (onYes)="unlinkSuperServer()" (onNo)="cancelUnlinkSuperServer()">
    </confirmation-dialog>

    <confirmation-dialog message="Are you sure you want to unlink this child server?"
      [display]="displayUnlinkSubServerConfirm"
      (onYes)="unlinkSubServer()" (onNo)="cancelUnlinkSubServer()">
    </confirmation-dialog>


  </div>
